// /src/components/CTAButtons.jsx
import React from 'react';
import { ArrowRight } from 'lucide-react';

export const ImagePlaceholder = ({ text, className = '', aspect = 'aspect-video' }) => (
  <div
    className={`flex items-center justify-center bg-[#EDE8E0] border border-dashed border-[#b03121]/40 text-[#5a4a42] font-['Lora',_serif] text-sm md:text-base text-center p-6 ${aspect} ${className}`}
  >
    {text}
  </div>
);

/**
 * Image card usata sopra le card prodotto.
 * Mostra l'immagine reale con object-cover; fallback al placeholder testuale se manca src.
 */
export const ProductImage = ({ src, alt, className = '', aspect = 'aspect-[4/3] md:aspect-square' }) => {
  if (!src) return <ImagePlaceholder text={`[ ${alt} ]`} className={className} aspect={aspect} />;
  return (
    <div className={`relative overflow-hidden ${aspect} ${className}`}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
      />
    </div>
  );
};

export const PrimaryCTA = ({
  onClick,
  className = '',
  children = 'Clicca per 2,50€ di sconto',
  testid = 'primary-cta-discount',
}) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    className={`inline-flex items-center justify-center bg-[#b03121] hover:bg-[#8e261a] text-white font-['Poppins',_sans-serif] font-bold py-4 px-8 rounded-lg shadow-lg transition-all transform hover:-translate-y-1 cta-primary ${className}`}
  >
    {children}
  </button>
);

export const SecondaryCTA = ({
  text,
  href = '#',
  className = '',
  onClick,
  testid = 'secondary-cta',
}) => (
  <a
    href={href}
    onClick={onClick}
    data-testid={testid}
    className={`inline-flex items-center justify-center border-2 border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white text-[#1A1A1A] font-['Poppins',_sans-serif] font-bold py-3 px-6 rounded-lg transition-colors ${className}`}
  >
    {text}
  </a>
);

export const MenuLink = ({ href, label, onClick, testid }) => (
  <a
    href={href}
    onClick={onClick}
    data-testid={testid}
    className="inline-flex items-center gap-2 mt-4 text-[#b03121] hover:text-[#8e261a] font-['Poppins',_sans-serif] font-semibold text-base border-b-2 border-[#b03121]/40 hover:border-[#b03121] transition-colors pb-1 self-start group"
  >
    <span>{label}</span>
    <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
  </a>
);
